import { render, staticRenderFns } from "./editProductForm.vue?vue&type=template&id=52235bc0"
import script from "./editProductForm.vue?vue&type=script&lang=js"
export * from "./editProductForm.vue?vue&type=script&lang=js"
import style0 from "./editProductForm.vue?vue&type=style&index=0&id=52235bc0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports